import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';

const CloudMapTrends = ({ trendsData }) => {
  const [chartData, setChartData] = useState({
    series: [{
      name: 'Total Resources',
      data: [0]
    }],
    options: {
      chart: {
        type: 'line',
        height: 350,
        toolbar: { show: true },
      },
      xaxis: {
        categories: ['No Data'],
        labels: {
          style: { fontSize: '12px' },
          rotate: -45,
        },
        title: {
          text: 'Scan Date',
          style: { fontSize: '14px', fontWeight: 'bold' },
        },
      },
      yaxis: {
        title: {
          text: 'Resource Count',
          style: { fontSize: '14px', fontWeight: 'bold', color: '#333' },
        },
      },
      colors: ['#2196f3'],
      markers: { size: 5 },
      stroke: { width: 2, curve: 'smooth' },
      legend: { position: 'bottom' },
    },
  });

  useEffect(() => {
    if (trendsData && Array.isArray(trendsData) && trendsData.length > 0) {
      const parseDate = (dateStr) => {
        const normalized = dateStr.replace(/T(\d{2})-(\d{2})-(\d{2})/, 'T$1:$2:$3');
        return new Date(normalized);
      };

      const getDateKey = (dateStr) => {
        const date = parseDate(dateStr);
        return date.toISOString().split('T')[0]; // YYYY-MM-DD
      };

      // Group by date and level - use TENANT level if available, otherwise ORG
      const dateGroups = {};
      trendsData.forEach(item => {
        if (!item?.scanDate) return;
        
        const dateKey = getDateKey(item.scanDate);
        const level = item.level || 'UNKNOWN';
        
        if (!dateGroups[dateKey]) {
          dateGroups[dateKey] = { date: parseDate(item.scanDate), byLevel: {} };
        }
        
        if (!dateGroups[dateKey].byLevel[level]) {
          dateGroups[dateKey].byLevel[level] = item.totalResources || 0;
        }
      });

      // For each date, prefer TENANT > ORG > ACCOUNT level
      const finalGroups = {};
      Object.entries(dateGroups).forEach(([dateKey, data]) => {
        const total = data.byLevel.TENANT || data.byLevel.ORG || data.byLevel.ACCOUNT || 0;
        finalGroups[dateKey] = { date: data.date, total };
      });

      const sortedDates = Object.entries(finalGroups)
        .sort(([, a], [, b]) => a.date - b.date);

      const categories = sortedDates.map(([, data]) => {
        const day = data.date.getDate().toString().padStart(2, '0');
        const month = data.date.toLocaleString('default', { month: 'short' });
        return `${day}-${month}`;
      });

      const resourceCounts = sortedDates.map(([, data]) => data.total);

      setChartData(prev => ({
        ...prev,
        options: {
          ...prev.options,
          xaxis: { ...prev.options.xaxis, categories },
        },
        series: [{ name: 'Total Resources', data: resourceCounts }],
      }));
    }
  }, [trendsData]);

  return (
    <div className="rounded shadow p-3 pb-0">
      <h5 className="fw-bold text-muted mb-3" style={{ color: '#333' }}>
        Resource Trends Over Time
      </h5>
      <Chart
        options={chartData.options}
        series={chartData.series}
        type="line"
        height="350"
      />
    </div>
  );
};

export default CloudMapTrends;
